import { render } from "./Skalaton.vue?vue&type=template&id=4ecbf98a&scoped=true"
const script = {}

import "./Skalaton.vue?vue&type=style&index=0&id=4ecbf98a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecbf98a"]])

export default __exports__